
const visitRecord = [
  {
    path: '/visit-record',
    name: 'visit-record',
    component: () => import('@/views/wxapp/visit-record'),
    redirect: '/visit-record/list',
    meta: {
      title: '外访'
    },
    children: [
      {
        path: 'list',
        name: 'visit-record-list',
        component: () => import('@/views/wxapp/visit-record/list'),
        meta: {
          title: '外访列表'
        }
      }
    ]
  },
  {
    path: '/follow',
    name: 'follow',
    component: () => import('@/views/wxapp/visit-record/follow'),
    meta: {
      title: '外访用户'
    }
  },
  {
    path: '/follow-record',
    name: 'follow-record',
    component: () => import('@/views/wxapp/visit-record/follow-record'),
    meta: {
      title: '跟进记录'
    }
  },
  {
    path: '/distribute',
    name: 'distribute',
    component: () => import('@/views/wxapp/visit-record/distribute'),
    meta: {
      title: '去分配'
    }
  }
]
export default visitRecord
